import { useState, useEffect } from 'react';
import { translations } from '../utils/translations';

export const useLanguage = () => {
  const [language, setLanguage] = useState(null);
  const [showLanguageModal, setShowLanguageModal] = useState(true);

  // Load saved language from localStorage on component mount
  useEffect(() => {
    const savedLanguage = localStorage.getItem('sweet-nina-language');
    if (savedLanguage && (savedLanguage === 'en' || savedLanguage === 'ro')) {
      setLanguage(savedLanguage);
      setShowLanguageModal(false);
    }
  }, []);

  // Change language and save to localStorage
  const changeLanguage = (lang) => {
    if (lang === 'en' || lang === 'ro') {
      setLanguage(lang);
      setShowLanguageModal(false);
      localStorage.setItem('sweet-nina-language', lang);
    }
  };

  // Show language modal
  const openLanguageModal = () => {
    setShowLanguageModal(true);
  };

  // Get current translations based on selected language
  const t = language ? translations[language] : translations.en;

  return {
    language,
    changeLanguage,
    showLanguageModal,
    setShowLanguageModal,
    openLanguageModal,
    translations: t,
    isLanguageSet: language !== null
  };
};